import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { t } from '../../../../locales';
import { connect } from 'react-redux';
import ContentWrapper from '../../../../components/ContentWrapper/';
import InnerWrapper from '../../../../components/InnerWrapper/';
import classNames from 'classnames';
import EnjoyApp from '../../components/EnjoyApp';
import VhisSummaryBoard from '../../components/VhisSummaryBoard';
import moment from 'moment';
import { isApp } from '../../../../utils/';
import {
  getCampaignDetail,
  getDisplayYearData,
  getDiamondLevelDays,
  getAxagoalIsFirstYear,
  getSilverHairChallengerLevelDays,
} from '../../selectors/vhisSelectors';
import {
  updateSummaryDisplayData,
  updateIsFirstYear,
  showMembershipTutorial,
  showAxaGoalSupport,
} from '../../actions/vhisAction';
import Dropdown from '../../components/Dropdown/Dropdown';
import './style.scss';
import PremiumRebateModalView from '../../../axagoal/components/PremiumRebateModalView';
import ScenarioError from '../../components/DashboardCardScenario/Error';

import InfoBlue from '../../../../assets/images/vhis/infoBlue@3x.png';
import {
  triggerPopupDisplayScreenChange,
  triggerPopupCloseScreenChange,
} from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';
import { controlTopBar, showTopbar } from '../../../../utils/AppUtils';
import { getDashboardPoliciesData } from '../../selectors/dashboardSelector';

interface CampaignDetail {
  bonusAchievedDays: string;
  totalAchieveDaysWithBonus: number;
  membershipStartDate: string;
  membershipEndDate: string;
  displayIcon: string;
  displayTxt: string;
  targetAchievedDisplayIcon: string;
  targetAchievedDisplayTxt: string;
  stepCount: [
    {
      month: string;
      numberOfAchievedDays: string;
    },
  ];
  totalAchievedDays: string;
  earlybirdBonusAchievedDays: string;
  lastMembershipStartDate: string;
  lastMembershipEndDate: string;
  lastYearStepCount: [
    {
      month: string;
      numberOfAchievedDays: string;
    },
  ];
  lastYearTotalAchievedDaysWithBonus: number;
  lastYearTotalAchievedDays: string;
  lastYearTotalBonusDays: string;
  lastYearEarlybirdBonusAchievedDays: string;
  totalBonusDays: string;
  currentAchievedDays: string;
  targetAchievedDays: string;
  stepCountMultiAxaIdErrorFlag: string;
}

interface OnBoardingScreenProps {
  match: {
    params: {
      membershipYear: string;
      id: string;
      entityCode: string;
    };
  };
  finalLevelDays: number;
  campaignDetail: CampaignDetail;
  isLapsedPolicy: boolean;
  showHideModalDispatch: (showHideModal: boolean) => void;
  updateDisplayYearDispatch: (displayYear: string) => void;
  setIsFirstYear: (isFirstYear: boolean) => void;
  onShowMembershipTutorial: (ruleType: string) => void;
  onShowAxaGoalSupport: (entityCode: string, ruleType: 'SH' | 'WGP') => void;
  policy?: any;
  ruleType?: 'WGP' | 'SH';
}
interface OnBoardingScreenState {
  selectedYear: string;
  isShowPremiumRebateModal: boolean;
  policy: any;
}

class OnBoardingScreen extends Component<
  OnBoardingScreenProps,
  OnBoardingScreenState
> {
  constructor(props: OnBoardingScreenProps) {
    super(props);
    const date = new Date();
    const curYear = date.getFullYear();
    this.state = {
      selectedYear: curYear.toString(),
      isShowPremiumRebateModal: false,
    };
    this.buildMembershipOptions = this.buildMembershipOptions.bind(this);
    this.getCurrentYear = this.getCurrentYear.bind(this);
    this.getPreviousYear = this.getPreviousYear.bind(this);
    this.onSelectMemYear = this.onSelectMemYear.bind(this);
    this.togglePremiumRebateModal = this.togglePremiumRebateModal.bind(this);
  }

  componentDidMount() {
    const { membershipYear } = this.props.match.params;
    const { isLapsedPolicy } = this.props;
    showTopbar();
    controlTopBar(true);
    if (membershipYear === 'PMY' || isLapsedPolicy) {
      const date = new Date();
      const curYear = date.getFullYear();
      const previousYear = curYear - 1;
      this.setState({
        selectedYear: previousYear.toString(),
      });
      this.props.setIsFirstYear(false);
    } else {
      this.props.setIsFirstYear(true);
    }
  }

  updateDisplayYear(event: any) {
    this.props.updateDisplayYearDispatch(event.target.value);
  }

  dataMomentFormat(date: string) {
    return moment(date).format('DD/MM/YYYY');
  }

  buildMembershipOptions() {
    return [this.getCurrentYear(), this.getPreviousYear()];
  }

  getCurrentYear() {
    const date = new Date();
    const curYear = date.getFullYear();
    return curYear;
  }

  getPreviousYear() {
    const { lastMembershipStartDate, lastMembershipEndDate } =
      this.props.campaignDetail;
    const date = new Date();
    const curYear = date.getFullYear();
    const previousYear = curYear - 1;
    if (lastMembershipStartDate && lastMembershipEndDate) {
      return previousYear;
    } else {
      return '';
    }
  }

  onSelectMemYear(year: any) {
    const date = new Date();
    const curYear = date.getFullYear();
    const isFirstYear = year === curYear.toString();
    this.props.setIsFirstYear(isFirstYear);
    this.setState(
      {
        selectedYear: year,
      },
      () => {},
    );
  }

  togglePremiumRebateModal(toggle: boolean) {
    if (toggle) {
      triggerPopupDisplayScreenChange('HS-AXAGoal-AcSummary-level-pop');
    } else {
      triggerPopupCloseScreenChange();
    }
    this.setState({
      isShowPremiumRebateModal: toggle,
    });
  }

  render() {
    const checkIsApp = isApp();
    const {
      finalLevelDays,
      onShowMembershipTutorial,
      onShowAxaGoalSupport,
      isLapsedPolicy,
      ruleType,
    } = this.props;
    const { selectedYear } = this.state;
    const {
      totalAchievedDays,
      totalAchieveDaysWithBonus,
      displayIcon,
      displayTxt,
      stepCount,
      totalBonusDays,
      earlybirdBonusAchievedDays,
      targetAchievedDisplayIcon,
      targetAchievedDisplayTxt,
      membershipStartDate,
      membershipEndDate,
      lastMembershipStartDate,
      lastMembershipEndDate,
      lastYearTotalAchievedDaysWithBonus,
      lastYearTotalAchievedDays,
      lastYearTotalBonusDays,
      lastYearStepCount,
      currentAchievedDays,
      targetAchievedDays,
      stepCountMultiAxaIdErrorFlag,
    } = this.props.campaignDetail;
    const { id: policyNumber, entityCode } = this.props.match.params;
    const vhisAsClasses = classNames({
      'vhis-as': true,
      'vhis-as--withPaddingBottom': !checkIsApp,
      'vhis-as__wrapper': true,
    });

    const membershipYears = this.buildMembershipOptions().filter(
      (item) => item,
    );
    const date = new Date();
    const curYear = date.getFullYear();
    const isFirstYear = selectedYear === curYear.toString();

    const offsetWidth = document.body.offsetWidth;
    const isWidthLess769 = offsetWidth < 769;
    return (
      <div className={vhisAsClasses}>
        <PremiumRebateModalView
          isShowModal={this.state.isShowPremiumRebateModal}
          onHideModal={() => this.togglePremiumRebateModal(false)}
          ruleType={ruleType}
        />

        <ContentWrapper className="relative-position">
          {/* Achievement Summary start */}
          <div className="vhis-as">
            {stepCountMultiAxaIdErrorFlag === 'Y' && (
              <div className="multipleAxaIdErrorOverlay">
                <ScenarioError policyNumber={policyNumber} />
              </div>
            )}
            {!checkIsApp && (
              <h1 className="vhis-as__title">{t('ACHIEVEMENTSUMMARYTITLE')}</h1>
            )}
            {membershipYears.length === 2 && (
              <div className="vhis-as__membership-dropdown-container">
                <div className="vhis-as__membership-dropdown-title">
                  {t('COMMON_MEMBERSHIP_YEAR')}
                </div>
                <Dropdown value={selectedYear} onChange={this.onSelectMemYear}>
                  {!isLapsedPolicy && (
                    <option value={curYear}>
                      {t('CURRENT_MEMBERSHIP_YEAR')}
                    </option>
                  )}
                  <option value={curYear - 1}>
                    {t('PREVIOUS_MEMBERSHIP_YEAR')}
                  </option>
                </Dropdown>
              </div>
            )}
            <p className="vhis-as__content vhis-as__content--mb20">
              <span className="vhis-as__content__label">
                {t('MEMBERSHIP_PERIOD')}
                <img
                  className="info-blue"
                  src={InfoBlue}
                  alt=""
                  onClick={() => onShowMembershipTutorial(ruleType)}
                  data-enable-ga
                  data-ga-type="button"
                  data-ga-text="tooltip"
                />
              </span>
              {isWidthLess769 && <br />}{' '}
              {isFirstYear
                ? this.dataMomentFormat(
                    membershipStartDate ? membershipStartDate : '',
                  )
                : this.dataMomentFormat(
                    lastMembershipStartDate ? lastMembershipStartDate : '',
                  )}{' '}
              -{' '}
              {isFirstYear
                ? this.dataMomentFormat(
                    membershipEndDate ? membershipEndDate : '',
                  )
                : this.dataMomentFormat(
                    lastMembershipEndDate ? lastMembershipEndDate : '',
                  )}
            </p>
            <InnerWrapper>
              <VhisSummaryBoard
                sImgSrc={
                  (isFirstYear
                    ? totalAchieveDaysWithBonus
                    : lastYearTotalAchievedDaysWithBonus) >= finalLevelDays
                    ? targetAchievedDisplayIcon
                    : displayIcon
                }
                sImageDes={
                  (isFirstYear
                    ? totalAchieveDaysWithBonus
                    : lastYearTotalAchievedDaysWithBonus) >= finalLevelDays
                    ? targetAchievedDisplayTxt
                    : displayTxt
                }
                nArchievedDate={
                  isFirstYear ? totalAchievedDays : lastYearTotalAchievedDays
                }
                nBonusDays={
                  isFirstYear ? totalBonusDays : lastYearTotalBonusDays
                }
                aArchievedData={isFirstYear ? stepCount : lastYearStepCount}
                currentAchievedDays={currentAchievedDays}
                targetAchievedDays={targetAchievedDays}
                isApp={checkIsApp}
                isFirstYear={isFirstYear}
                togglePremiumRebateModal={this.togglePremiumRebateModal}
                ruleType={ruleType}
                entityCode={entityCode}
              >
                {ruleType === 'WGP' &&
                  (isFirstYear ? totalBonusDays : lastYearTotalBonusDays) !==
                    '0' && (
                    <div>
                      {/* <p className="summary-board__detail__remark">{t('ACHIEVEMENT_SUMMARY_REMARK1')}</p> */}
                      {parseInt(
                        isFirstYear ? totalBonusDays : lastYearTotalBonusDays,
                      ) === 50 && (
                        <div className="summary-board__detail__footer-remark">
                          {t('ACHIEVEMENT_SUMMARY_MODAL_CONTENT1')}
                        </div>
                        // <p className="summary-board__detail__remark">+ {isFirstYear ? totalBonusDays : lastYearTotalBonusDays} <span className="summary-board__detail__achieved">{t('DAYS2')}</span> : <span dangerouslySetInnerHTML={{  __html: memoSanitize( t(`ACHIEVEMENT_SUMMARY_REMARK2`) ) }}></span></p>
                      )}
                      {parseInt(
                        isFirstYear ? totalBonusDays : lastYearTotalBonusDays,
                      ) === 75 && (
                        <div className="summary-board__detail__footer-remark">
                          {t('ACHIEVEMENT_SUMMARY_MODAL_CONTENT2')}
                        </div>
                        // <p className="summary-board__detail__remark">+ {isFirstYear ? totalBonusDays : lastYearTotalBonusDays} <span className="summary-board__detail__achieved">{t('DAYS2')}</span> : <span dangerouslySetInnerHTML={{  __html: memoSanitize( t(`ACHIEVEMENT_SUMMARY_REMARK_EARLY_BIRD`) ) }}></span></p>
                      )}
                    </div>
                  )}
              </VhisSummaryBoard>
              <div className="vhis-as-footer content-align-vertical">
                <div className="vhis-as-footer-title">
                  {t('AXA_GOAL_RECORD_PROBLEM')}
                </div>
                <div className="vhis-as-footer-button">
                  <button
                    className="emma-stylesheet-primary-ghost-button"
                    data-enable-ga
                    data-ga-type="button"
                    onClick={() => onShowAxaGoalSupport(entityCode, ruleType)}
                  >
                    {t('AXA_GOAL_RECORD_SUPPORT')}
                  </button>
                </div>
              </div>
            </InnerWrapper>
            {/* <VhisDetail /> */}
            {/* {<VhisHelp />} */}
            {!checkIsApp && <EnjoyApp />}
          </div>
          {/* Achievement Summary end */}
        </ContentWrapper>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const isFirstYear = getAxagoalIsFirstYear(state);
    const displayData = getDisplayYearData(state);
    const wgpDiamondLevelDays = getDiamondLevelDays(state);
    const shChallengerLevelDays = getSilverHairChallengerLevelDays(state);
    const dashboardPoliciesData = getDashboardPoliciesData(state);
    const { dashboardPolicies } = dashboardPoliciesData || {};

    let policy = null;
    let ruleType = ownProps?.match?.params?.ruleType || 'WGP';
    const policyNumber = ownProps?.match?.params?.id;
    if (policyNumber) {
      const dashBoardPolicy = dashboardPolicies?.find(
        (p) => p.policyNumber === policyNumber,
      );
      policy = dashBoardPolicy?.policyDetails;
      if (policy && policy.isSilverHairPolicyFlag === 'Y') {
        ruleType = 'SH';
      }
    }
    const campaignDetail = getCampaignDetail(state, isFirstYear, ruleType);
    return {
      campaignDetail,
      displayData: displayData,
      finalLevelDays:
        ruleType === 'WGP' ? wgpDiamondLevelDays : shChallengerLevelDays,
      isLapsedPolicy:
        !!campaignDetail.isLapsedPolicy && campaignDetail.isLapsedPolicy === 'Y'
          ? true
          : false,
      policy,
      ruleType,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      updateDisplayYearDispatch: (displayYear: string) =>
        dispatch(updateSummaryDisplayData(displayYear)),
      setIsFirstYear: (isFirstYear: boolean) =>
        dispatch(updateIsFirstYear(isFirstYear)),
      onShowMembershipTutorial: (ruleType) =>
        dispatch(showMembershipTutorial(ruleType)),
      onShowAxaGoalSupport: (entityCode: string, ruleType: 'WGP' | 'SH') =>
        dispatch(showAxaGoalSupport(entityCode, ruleType)),
    };
  }
}

export default connect(
  OnBoardingScreen.mapStateToProps,
  OnBoardingScreen.mapDispatchToProps,
)(OnBoardingScreen);
